import { call, put, takeLatest } from "@redux-saga/core/effects";
import { message } from "antd";
import FileSaver from "file-saver";
import { request } from "../../../apiConfig/api";
import { authHeader } from "../../../utils/utils";
import { UrlConstants } from "../../../utils/ApiConstants";
import {
  createNewRecordFailure,
  createNewRecordSuccess,
  deleteRecordFailure,
  deleteRecordSuccess,
  downloadUserReportFailure,
  downloadUserReportSuccess,
  downloadUserTemplateFailure,
  downloadUserTemplateSuccess,
  getDataTableFailure,
  getDataTableSuccess,
  getEditFormFailure,
  getEditFormSuccess,
  getSearchFiltersFailure,
  getSearchFiltersSuccess,
  getUserDataByIdFailure,
  getUserDataByIdSuccess,
  getUserFailure,
  getUserSuccess,
  getViewFormFailure,
  getViewFormSuccess,
  saveUserDataByIdFailure,
  saveUserDataByIdSuccess,
  uploadUserRequestFailure,
  uploadUserRequestSuccess,
  uploadUserrProfileRequestFailure,
  uploadUserrProfileRequestSuccess,
  userFileUploadFailure,
  userFileUploadSuccess,
} from "./action";
import {
  CREATE_NEW_RECORD_REQUEST,
  DELETE_RECORD_REQUEST,
  DOWNLOAD_USER_REPORT_REQUEST,
  DOWNLOAD_USER_TEMPLATE_REQUEST,
  GET_DATA_TABLE_REQUEST,
  GET_EDIT_FORM_REQUEST,
  GET_SEARCH_FILTERS_REQUEST,
  GET_USERS_REQUEST,
  GET_USER_DATA_BY_ID_REQUEST,
  GET_VIEW_FORM_REQUEST,
  SAVE_USER_DATA_BY_ID_REQUEST,
  UPLOAD_USER_REQUEST,
  USER_FILE_UPLOAD_REQUEST,
  UPLOAD_USERROFILE_REQUEST,
} from "./actionTypes";
import { replaceWithCurrentApiVersion } from "../../../utils/api";

const BASE_URL = `${UrlConstants.BASE_URL}`;
// const BASE_URL = "http://localhost:8080/";

export function* getAllUsersData(payload: any): Generator {
  const { api, size, page, params } = payload?.payload;
  let searchUrl = "&search=";
  if (params) {
    Object.keys(params).map((key: string) => {
      console.log("filter.....hhh.." + key + "..value..." + params[key]?.value);
      if (params[key]?.value === null) {
        return false;
      }
      else if ((key === "paymentMode") && (window.location.pathname === "/payments/systemPis")) {
        if (params[key]?.value === "B") {
          let val = "P,Q,D";
          searchUrl += `${key}:${params[key]?.operator || "eq"}${val};`;
        } else {
          searchUrl += `${key}:${params[key]?.operator || "eq"}${params[key]?.value};`;
        }
      }
      else {
        searchUrl += `${key}:${params[key]?.operator || "eq"}${params[key]?.value};`;
      }
    });
  }
  if (!params) {
    searchUrl = "";
  }
  try {
    if (api) {
      let charToAppendParams = api.includes('?') ? '&' : '?';
      const result: any = yield call(request, {
        url: `${BASE_URL}${replaceWithCurrentApiVersion(api)}${charToAppendParams}size=${size}&page=${page}${searchUrl}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: authHeader().Authorization,
        },
        // params: searchUrl,
      });
      yield put(getUserSuccess(result));
    }
  } catch (error) {
    yield put(getUserFailure(error));
  }
}

export function* donwloadUserTemplate(): Generator {
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}users/bulk/template`,
      responseType: "arraybuffer",
      method: "GET",
      headers: {
        "content-type": "Content-Disposition",
        authorization: `${authHeader().Authorization}`,
      },
    });
    if (result) {
      const blob: Blob = new Blob([result], {
        type: "application/vnd.ms-excel",
      });
      FileSaver.saveAs(blob, "users_upload_template.xlsx");
    }

    yield put(downloadUserTemplateSuccess({ loading: false, data: true }));
    message.success({ duration: 3, content: "File downloaded Successfully." });
  } catch (error) {
    yield put(downloadUserTemplateFailure(error));
    message.error({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

export function* donwloadUserReport(report: any): Generator {
  console.log(report.payload);
  const downloadURI = report.payload;

  if (downloadURI.includes("generate-url-info")) {
    try {
      const result: any = yield call(request, {
        url: `${BASE_URL}${replaceWithCurrentApiVersion(report.payload)}`,
        method: "GET",
        headers: {
          authorization: `${authHeader().Authorization}`,
          "Access-Control-Allow-Origin": "*",
        },
      });

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = result?.downloadUrl;
      a.download = result?.fileName; // The name you want to save the file as
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      yield put(downloadUserReportSuccess({ loading: false, data: true }));
      message.success({ duration: 3, content: "File downloaded Successfully." });

    } catch (error) {
      yield put(downloadUserReportFailure(error));
    }
  } else {
    try {
      const result: any = yield call(fetch, `${BASE_URL + replaceWithCurrentApiVersion(report.payload)}`, {
        headers: {
          authorization: `${authHeader().Authorization}`,
        },
      });

      if (result) {

        const blob: any = yield call([result, result.blob]);

        // Extract filename from Content-Disposition header if present
        let filename = `${report.payload}`; // Default filename
        const contentDisposition = result.headers.get('Content-Disposition');
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+)"/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        if (filename.includes("/")) {
          filename = filename.substring(filename.lastIndexOf("/") + 1);
        }
        FileSaver.saveAs(blob, filename);
      }

      yield put(downloadUserReportSuccess({ loading: false, data: true }));
      message.success({ duration: 3, content: "File downloaded Successfully." });
    } catch (error) {
      yield put(downloadUserReportFailure(error));
      message.error({
        duration: 3,
        content: "Something went wrong! Please try again.",
      });
    }
  }
}

export function* uploadUsers(payload: any): Generator {
  const selectedFile = payload?.payload.selectedFile;
  const formData = new FormData();

  formData.append("file", selectedFile);
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}users/bulk`,
      method: "POST",
      headers: {
        authorization: `${authHeader().Authorization}`,
      },
      data: formData,
    });
    yield put(uploadUserRequestSuccess({ loading: false, data: result }));
    message.success({ duration: 3, content: "File uploaded Successfully." });
  } catch (error) {
    yield put(uploadUserRequestFailure(error));
    message.error({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

export function* userProfilefileUpload(payload: any): Generator {

  const selectedFile = payload?.payload.selectedFile;
  const formData = new FormData();

  formData.append("fileName", selectedFile);
  formData.append("fieldName", "myInfoFile");
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}users/platform/document/my-info-details/upload`,
      method: "POST",
      headers: {
        authorization: `${authHeader().Authorization}`,
      },
      data: formData,
    });
    console.log(result)
    yield put(uploadUserrProfileRequestSuccess({ loading: false, data: result }));
    message.success({ duration: 3, content: "File uploaded Successfully." });
  } catch (error) {
    yield put(uploadUserrProfileRequestFailure(error));
    message.error({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

export function* userfileUpload(payload: any): Generator {
  const selectedFile = payload?.payload.file;
  const formData = new FormData();

  formData.append("file", selectedFile);
  formData.append("moduleName", payload?.payload.moduleName);
  formData.append("fileContext", payload?.payload.fileContext);
  formData.append("extraParam", payload?.payload.extraParam);
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}platform/upload`,
      method: "POST",
      headers: {
        authorization: `${authHeader().Authorization}`,
      },
      data: formData,
    });
    yield put(userFileUploadSuccess({ loading: false, data: result }));
    message.success({ duration: 3, content: "File uploaded Successfully." });
  } catch (error) {
    yield put(userFileUploadFailure(error));
    message.error({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

export function* dataTable(payload: any): Generator {
  const { api } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(api)}`,
      method: "GET",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(getDataTableSuccess(result));
  } catch (error) {
    yield put(getDataTableFailure(error));
  }
}

export function* userSearchhFilters(payload: any): Generator {
  const { api } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(api)}`,
      method: "GET",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(getSearchFiltersSuccess(result));
  } catch (error) {
    yield put(getSearchFiltersFailure(error));
  }
}

export function* userEditForm(payload: any): Generator {
  const { blueprintApi } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(blueprintApi)}`,
      method: "GET",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(getEditFormSuccess(result));
  } catch (error) {
    yield put(getEditFormFailure(error));
  }
}

export function* viewFormData(payload: any): Generator {
  const { blueprintApi, recordId } = payload?.payload;
  const updatedBluePrintApi = blueprintApi?.replace("{recordId}", recordId);
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(updatedBluePrintApi)}`,
      method: "GET",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(getViewFormSuccess(result));
  } catch (error) {
    yield put(getViewFormFailure(error));
  }
}

export function* userDataById(payload: any): Generator {
  const { userId } = payload;
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}users/${userId}`,
      method: "GET",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(getUserDataByIdSuccess(result));
  } catch (error) {
    yield put(getUserDataByIdFailure(error));
  }
}

export function* saveUserDataById(payload: any): Generator {
  const { api, recordId, data } = payload?.payload;
  const updatedBluePrintApi = api?.replace("{recordId}", recordId);
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(updatedBluePrintApi)}`,
      method: "PUT",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
      data: data,
    });
    yield put(saveUserDataByIdSuccess(result));
  } catch (error) {
    console.log(error, "Error")
    yield put(saveUserDataByIdFailure(error));
  }
}

export function* createNewRecord(payload: any): Generator {
  const { api, data } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(api)}`,
      method: "POST",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
      data: data,
    });
    yield put(createNewRecordSuccess(result));
  } catch (error) {
    yield put(createNewRecordFailure(error));
  }
}

export function* deleteRecord(payload: any): Generator {
  const { api, recordId } = payload?.payload;
  const updatedBluePrintApi = api?.replace("{recordId}", recordId);
  try {
    yield call(request, {
      url: `${BASE_URL}${replaceWithCurrentApiVersion(updatedBluePrintApi)}`,
      method: "DELETE",
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(deleteRecordSuccess([recordId]));
  } catch (error) {
    yield put(deleteRecordFailure(error));
  }
}

function* usersSaga() {
  yield takeLatest(GET_USERS_REQUEST, getAllUsersData);
  yield takeLatest(DOWNLOAD_USER_TEMPLATE_REQUEST, donwloadUserTemplate);
  yield takeLatest(DOWNLOAD_USER_REPORT_REQUEST, donwloadUserReport);
  yield takeLatest(UPLOAD_USER_REQUEST, uploadUsers);
  yield takeLatest(UPLOAD_USERROFILE_REQUEST, userProfilefileUpload);
  yield takeLatest(USER_FILE_UPLOAD_REQUEST, userfileUpload);
  yield takeLatest(GET_DATA_TABLE_REQUEST, dataTable);
  yield takeLatest(GET_SEARCH_FILTERS_REQUEST, userSearchhFilters);
  yield takeLatest(GET_EDIT_FORM_REQUEST, userEditForm);
  yield takeLatest(GET_VIEW_FORM_REQUEST, viewFormData);
  yield takeLatest(GET_USER_DATA_BY_ID_REQUEST, userDataById);
  yield takeLatest(SAVE_USER_DATA_BY_ID_REQUEST, saveUserDataById);
  yield takeLatest(CREATE_NEW_RECORD_REQUEST, createNewRecord);
  yield takeLatest(DELETE_RECORD_REQUEST, deleteRecord);
}

export default usersSaga;
